import request from '@/utils/request'


// 查询分销收益记录列表
export function listDistributionRecord(query) {
  return request({
    url: '/user/distributionRecord/list',
    method: 'get',
    params: query
  })
}

// 查询分销收益记录分页
export function pageDistributionRecord(query) {
  return request({
    url: '/user/distributionRecord/page',
    method: 'get',
    params: query
  })
}

// 查询分销收益记录详细
export function getDistributionRecord(data) {
  return request({
    url: '/user/distributionRecord/detail',
    method: 'get',
    params: data
  })
}

// 新增分销收益记录
export function addDistributionRecord(data) {
  return request({
    url: '/user/distributionRecord/add',
    method: 'post',
    data: data
  })
}

// 修改分销收益记录
export function updateDistributionRecord(data) {
  return request({
    url: '/user/distributionRecord/edit',
    method: 'post',
    data: data
  })
}

// 删除分销收益记录
export function delDistributionRecord(data) {
  return request({
    url: '/user/distributionRecord/delete',
    method: 'post',
    data: data
  })
}
